<template>
  <main class="dashboard review-form">
    <div class="container-fluid container-fluid--max">
      <div class="card">
        <div class="card-body">
          <router-link :to="{ name: 'productRegistrations' }" tag="a" class="back btn btn-link uppercase smaller pl-0">
            <i class="back__icon fa fa-close mr-h" aria-hidden="true"></i>Retour
          </router-link>
          <section class="prdt-review-form px-lg-5 mt-2">
            <h1 class="dashboard__title heading-primary text-center mb-5">
              Rédiger un avis pour votre {{ product.type }} : <strong>{{ product.name }}</strong>
            </h1>
            <vv-observer tag="form" v-slot="{ invalid }" @submit.prevent="submit">
              <h2 class="dashboard__title heading-secondary">Note globale</h2>
              <hr class="separator-deco">
              <div class="row mt-4">
                <div class="col-md">
                  <label class="access-form__label">
                    Sur une échelle de 1 à 10, comment jugeriez-vous la marque et les produits Bestove ?
                    <abbr title="Ce champ est obligatoire">*</abbr>
                  </label>
                  <Rating :max-stars="10" v-model="params.bestove_rating" />
                </div>
                <div class="col-md">
                  <div class="form-group">
                    <label class="access-form__label">
                      Avez-vous des commentaires supplémentaires à apporter concernant la marque Bestove ?
                    </label>
                    <textarea class="form-control" v-model="params.bestove_feedback"></textarea>
                  </div>
                </div>
              </div>
              <h2 class="dashboard__title heading-secondary">Informations produit</h2>
              <hr class="separator-deco">
              <div class="row mt-4">
                <div class="col-md">
                  <vv-provider tag="div" v-slot="{ errors, classes }" rules="required" class="form-group" ref="known" name="connaissance">
                    <label class="access-form__label">
                      Comment avez-vous connu la marque Bestove ?
                      <abbr title="Ce champ est obligatoire">*</abbr>
                    </label>
                    <v-select
                      :options="knownOptions"
                      :reduce="options => options.value"
                      label="name"
                      v-model="params.known_through"
                      :searchable="false"
                      :clearable="false"
                      :class="{ 'is-error': classes.invalid }"
                      @search:blur="validate">
                    </v-select>
                    <p class="mb-0">
                      <small class="text-danger">{{ errors[0] }}</small>
                    </p>
                  </vv-provider>
                  <label class="access-form__label">
                    Comment jugez-vous le rapport qualité / finitions / prix de votre poêle Bestove ?
                    <abbr title="Ce champ est obligatoire">*</abbr>
                  </label>
                  <Rating v-model="params.product_rating" />
                </div>
                <div class="col-md">
                  <div class="form-group">
                    <label class="access-form__label">Avez-vous des commentaires à apporter sur votre poêle Bestove ?</label>
                    <textarea class="form-control" v-model="params.product_comment"></textarea>
                  </div>
                </div>
              </div>
              <h2 class="dashboard__title heading-secondary">Installation</h2>
              <hr class="separator-deco">
              <div class="row mt-4">
                <div class="col-md">
                  <vv-provider tag="div" class="form-group" rules="required">
                    <label class="access-form__label">
                      Êtes-vous passé par un professionnel agrée pour l’installation de votre {{ product.type }} ?
                      <abbr title="Ce champ est obligatoire">*</abbr>
                    </label>
                    <div class="custom-control custom-radio">
                      <input type="radio" id="proYes" v-model="params.installed_by_professional" :value="true" class="custom-control-input">
                      <label for="proYes" class="custom-control-label text-secondary">Oui</label>
                    </div>
                    <div class="custom-control custom-radio">
                      <input type="radio" id="proNo" v-model="params.installed_by_professional" :value="false" class="custom-control-input">
                      <label for="proNo" class="custom-control-label text-secondary">Non</label>
                    </div>
                  </vv-provider>
                </div>
              </div>
              <div v-for="(label, feedback) in feedbacks" :key="feedback">
                <hr class="mt-0" />
                <div class="row">
                  <div class="col-md">
                    <vv-provider tag="div" class="form-group" rules="required">
                      <label class="access-form__label">
                        {{ label }}
                        <abbr title="Ce champ est obligatoire">*</abbr>
                      </label>
                      <div class="custom-control custom-radio">
                        <input type="radio" :id="feedback + 'Yes'" v-model="params[`satisfied_by_${feedback}`]" :value="true" class="custom-control-input">
                        <label :for="feedback + 'Yes'" class="custom-control-label text-secondary">Oui</label>
                      </div>
                      <div class="custom-control custom-radio">
                        <input type="radio" :id="feedback + 'No'" v-model="params[`satisfied_by_${feedback}`]" :value="false" class="custom-control-input">
                        <label :for="feedback + 'No'" class="custom-control-label text-secondary">Non</label>
                      </div>
                    </vv-provider>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md">
                    <div class="form-group">
                      <label class="access-form__label">Points positifs</label>
                      <textarea class="form-control" v-model="params[`positive_${feedback}_feedback`]"></textarea>
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="form-group">
                      <label class="access-form__label">Points négatifs</label>
                      <textarea class="form-control" v-model="params[`negative_${feedback}_feedback`]"></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center">
                <s-button :loading="loading" @submit="submit" :css-class="'px-5 btn-' + $mainColor" :disabled="invalid || loading">
                  Enregistrer
                </s-button>
              </div>
            </vv-observer>
          </section>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapState } from 'vuex'
import Rating from '@/components/ui/StarRating'
export default {
  name: 'ProductRegistrationReview',
  components: {
    Rating
  },
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      loading: false,
      params: {},
      error: {},
      knownOptions: [
        { name: 'En magasin', value: 'shop' },
        { name: 'Sur internet', value: 'web' },
        { name: 'Par magazines spécialisés', value: 'magazine' },
        { name: 'Autre', value: 'other' }
      ],
      feedbacks: {
        advices: 'Êtes-vous satisfait des conseils apportés (démarrage, entretien, ...) ?',
        manual: 'La notice d\'installation et de démarrage vous a-t-elle paru assez claire ?'
      }
    }
  },
  computed: {
    ...mapState(['currentClient', 'clientAuth', 'productRegistrations']),
    product () {
      let pr = this.productRegistrations.find(pr => pr.id === parseInt(this.id))
      return {
        name: pr.product.name,
        type: pr.product_type === 'Stove' ? 'poêle' : pr.product_type === 'Hearth' ? 'cheminée' : 'produit'
      }
    }
  },
  methods: {
    submit () {
      this.loading = true
      this.$http.post('/clients/' + this.currentClient.id + '/product_registrations/' + this.id + '/product_reviews', this.params, {
        headers: this.clientAuth
      }).then(resp => {
        this.$store.dispatch('fetchProductRegistrations').then(() => {
          this.$store.dispatch('fetchReviews').then(() => {
            this.loading = false
            this.$router.push({ name: 'reviews', query: { id: resp.data.id }, hash: `#product_review${resp.data.id}` })
          })
        })
      }).catch(err => {
        this.loading = false
        this.error = {}
        if (err.response.status === 422) {
          let e = err.response.data
          this.error = _.reduce(e, (result, value, key) => {
            result[key] = value[0]
            return result
          }, {})
        }
      })
    },
    validate () {
      this.$refs.known.validate()
    }
  }
}
</script>
